import React, { type FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IconWarningCircle } from "~/components/icon";

import { goLiveRequested } from "../../app/state/view/timeline/TimelineActions";
import { selectTimestampDate } from "../../app/state/view/timeline/TimelineSelectors";
import { DocLink } from "../../components/react/docLink/DocLink";
import { Tooltip } from "../../components/react/tooltip/Tooltip";

export const SnapshotIndication: FC = () => {
	const dispatch = useDispatch();
	const timestamp = useSelector(selectTimestampDate);

	if (!timestamp) {
		return null;
	}

	const tooltip = (
		<div className="p-1 text-13">
			The timeline is currently paused. Whilst traveling back in time is useful when doing an investigation, it also
			means you are not seeing any live data. <DocLink capture="noop" slug="ui-topology-time" text="Learn more" />
		</div>
	);

	return (
		<div
			className="flex w-64 shrink-0 items-stretch gap-x-1 self-stretch text-13"
			data-testid="snapshot-indication"
			data-tourid="snapshot-indication"
		>
			<Tooltip
				overlayStyle={{
					zIndex: 3000,
					maxWidth: "346px",
				}}
				title={tooltip}
			>
				<div className="flex items-center gap-x-2 text-yellow-500">
					<IconWarningCircle className="text-base" />
					You are in time travel mode.
				</div>
			</Tooltip>
			<Tooltip title={<div className="p-1 text-13">Show changes in real-time</div>}>
				<a
					className="flex items-center font-medium text-gray-100 underline hover:no-underline"
					data-testid="snapshot-indication-back-to-live"
					onClick={() => dispatch(goLiveRequested())}
				>
					Go live
				</a>
			</Tooltip>
		</div>
	);
};
